export const ERROR_MESSAGES: Record<string, string> = {
  ProblemaDadosEnviados: "Verifique os dados preenchidos e tente novamente",
  UsuarioNaoCadastrado: "Usuário não encontrado",
  CredenciaisInvalidas: "Usuário e/ou senha incorreto(s)",
  PlanoCancelado: "Seu plano foi cancelado",
  ProblemaPagamento:
    "Houve um problema no durante o pagamento da sua assinatura",
};
